module.exports = __webpack_public_path__ + "img/Lupe.dba8b3e3.png";